export default {
    namespaced: true,
    state: () => ([]),
    getters: {},
    actions: {
        load: function({commit}) {
            this.$xhr.get('/api/permissions').then(
                data => {
                    commit('set', data.result)
                }
            );
        }
    },
    mutations: {
        set: (state, permissions) => state.push(...permissions),
    },
    modules: {},
}
